import { SlideWaveBackground } from "@/components/investors/slides/SlideWaveBackground";

export function IntroCoverSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="relative flex flex-col justify-end h-full">
      <SlideWaveBackground />
      <div className="relative z-10 max-w-4xl mt-auto">
        <h1 className="text-[48px] font-light tracking-tight mb-6 font-[family-name:var(--font-heading)]">
          Building the AI workforce
          <br />
          for regulated industries.
        </h1>
        <p className="text-[18px] text-[var(--color-fg-secondary)] leading-relaxed font-light">
          AI agents that work under the same compliance, audit, and governance
          standards your business already operates by.
        </p>
      </div>
    </div>
  );
}
